const QUOTES = [
  {
    text: '准备跳槽前看到某厂的组织调整分析，避开了明显在收缩的部门，少走了不少弯路。',
    who: '后端开发，待入职某大厂',
  },
  {
    text: '竞业那篇写得清楚，我第一次知道补偿金没到账可以谈解除。作为普通打工人很受用。',
    who: '算法工程师',
  },
  {
    text: '这里的爆料不标题党，会标「待核实」，看得出是真的在认真做核实，而不是博流量。',
    who: '十年经验的猎头顾问',
  },
  {
    text: '匿名投稿很安心，编辑只联系核对事实，没有追问我的身份。说真话的成本变低了。',
    who: '一位刚完成投稿的前员工',
  },
];

const STATS = [
  { num: '12w+', label: '每月活跃读者' },
  { num: '6', label: '行业栏目覆盖' },
  { num: '87%', label: '内容进入人工核实' },
  { num: '24h', label: '线索平均响应' },
];

export default function QuoteBand() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-400">
              <i className="ri-chat-heart-line" aria-hidden="true"></i>
              读者与社区
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-background-50 md:text-3xl">
              他们说，信息真的能改变决定
            </h2>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {STATS.map((s) => (
                <div key={s.label} className="rounded-lg border border-background-200/20 bg-background-50/5 p-4">
                  <p className="font-display text-2xl font-black text-accent-400">{s.num}</p>
                  <p className="mt-1 text-xs text-background-300">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-8">
            {QUOTES.map((q) => (
              <figure key={q.who} className="flex flex-col justify-between rounded-lg border border-background-200/20 bg-foreground-900/70 p-6">
                <div>
                  <span className="flex gap-1 text-accent-400" aria-hidden="true">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </span>
                  <blockquote className="mt-3 text-sm leading-7 text-background-200">「{q.text}」</blockquote>
                </div>
                <figcaption className="mt-4 flex items-center gap-2 text-xs text-background-400">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
                    <i className="ri-quill-pen-fill" aria-hidden="true"></i>
                  </span>
                  {q.who}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}